import { upcomingReminders } from '../meta/reminders';
import { setDailyReminders } from '../platform/notifications';
import { saves, todayKey } from './records';

/**
 * Brings the scheduled Daily reminders in line with the save: the setting, and whether today's
 * Daily is done. Called at boot, when the app hides, when a Daily is cleared and from Settings.
 */
export function syncDailyReminders(now = new Date()): void {
  const save = saves().save;
  const done = save.daily.bestTicks[todayKey(now)] !== undefined;
  void setDailyReminders(save.settings.dailyReminder ? upcomingReminders(now, done) : []);
}
